import {
  faBrandFacebook,
  faBrandInstagram,
  faBrandTiktok,
  faBrandXTwitter,
} from '@ng-icons/font-awesome/brands';
import {
  faSolidEquals,
  faSolidPersonCircleXmark,
  faSolidQuestion,
} from '@ng-icons/font-awesome/solid';
import {
  saxAddBold,
  saxAddCircleBold,
  saxArrowDownBold,
  saxArrowLeft2Bold,
  saxArrowLeft3Bold,
  saxArrowRight2Bold,
  saxArrowUp1Bold,
  saxBankBold,
  saxBuilding4Bold,
  saxCalendar1Bold,
  saxCalendarAddBold,
  saxCameraBold,
  saxChart3Bold,
  saxCheckBold,
  saxClipboardTextBold,
  saxClock1Bold,
  saxCloseCircleBold,
  saxCloudCrossBold,
  saxCoffeeBold,
  saxDevices1Bold,
  saxDocumentBold,
  saxDocumentSketchBold,
  saxDocumentText1Bold,
  saxDollarCircleBold,
  saxElement3Bold,
  saxEmojiSadBold,
  saxEyeBold,
  saxEyeSlashBold,
  saxFilterBold,
  saxForbiddenBold,
  saxGalleryAddBold,
  saxInfoCircleBold,
  saxLocationBold,
  saxLockBold,
  saxLogoutBold,
  saxMap1Bold,
  saxMessageQuestionBold,
  saxMinusBold,
  saxMinusCirlceBold,
  saxMoneysBold,
  saxMoneyTickBold,
  saxMoonBold,
  saxNotificationBingBold,
  saxNotificationBold,
  saxPeopleBold,
  saxPersonalcardBold,
  saxPrinterBold,
  saxProfile2userBold,
  saxRefresh2Bold,
  saxScanBarcodeBold,
  saxSend2Bold,
  saxSetting2Bold,
  saxShopBold,
  saxShoppingCartBold,
  saxSidebarLeftBold,
  saxSidebarRightBold,
  saxSmsBold,
  saxStatusUpBold,
  saxSun1Bold,
  saxTickCircleBold,
  saxTicketBold,
  saxTicketStarBold,
  saxTimer1Bold,
  saxTimerBold,
  saxTrashBold,
  saxUserBold,
  saxWarning2Bold,
  saxWifiBold,
} from '@ng-icons/iconsax/bold';
import {
  saxMessageQuestionBulk,
  saxTagCrossBulk,
} from '@ng-icons/iconsax/bulk';
import {
  saxAddCircleOutline,
  saxAddOutline,
  saxArrowDown1Outline,
  saxArrowLeftOutline,
  saxArrowRight3Outline,
  saxArrowUp2Outline,
  saxCalendar1Outline,
  saxClockOutline,
  saxLikeShapesOutline,
  saxMenu1Outline,
  saxMinusCirlceOutline,
  saxMinusOutline,
  saxMinusSquareOutline,
  saxRefreshOutline,
  saxSearchNormal1Outline,
  saxTicketOutline,
  saxUserOutline,
} from '@ng-icons/iconsax/outline';
import {
  remixBugLine,
  remixCheckDoubleFill,
  remixCheckFill,
  remixCloudFill,
  remixCloudOffFill,
  remixDownloadLine,
  remixExpandUpDownFill,
  remixProhibitedLine,
  remixUserCommunityFill,
  remixWifiFill,
  remixWifiOffFill,
} from '@ng-icons/remixicon';

export const ICONSAX_ICON_MAP = {
  wifiOn: saxWifiBold,
  cloudCross: saxCloudCrossBold,
  camera: saxCameraBold,
  qrCode: saxScanBarcodeBold,
  timer: saxTimer1Bold,
  statusUp: saxStatusUpBold,
  email: saxSmsBold,
  sun: saxSun1Bold,
  moon: saxMoonBold,
  devices: saxDevices1Bold,
  facebook: faBrandFacebook,
  instagram: faBrandInstagram,
  x: faBrandXTwitter,
  tiktok: faBrandTiktok,
  userOutline: saxUserOutline,
  ticketOutline: saxTicketOutline,
  menu: saxMenu1Outline,
  eye: saxEyeBold,
  eyeSlash: saxEyeSlashBold,
  ticketStar: saxTicketStarBold,
  ticket: saxTicketBold,
  calendar: saxCalendar1Bold,
  mapPin: saxLocationBold,
  clock: saxClock1Bold,
  check: saxCheckBold,
  coffee: saxCoffeeBold,
  circle: saxAddCircleBold,
  locationOn: saxLocationBold,
  star: saxTicketStarBold,
  organizer: saxPersonalcardBold,
  search: saxSearchNormal1Outline,
  clear: saxTagCrossBulk,
  xMark: saxAddOutline,
  dashboard: saxElement3Bold,
  chart: saxChart3Bold,
  money: saxMoneysBold,
  moneyTick: saxMoneyTickBold,
  shop: saxShopBold,
  arrowUp: saxArrowUp2Outline,
  arrowDown: saxArrowDown1Outline,
  arrowRight: saxArrowRight3Outline,
  bell: saxNotificationBold,
  notificationBell: saxNotificationBingBold,
  trash: saxTrashBold,
  refresh: saxRefresh2Bold,
  left: saxArrowLeft2Bold,
  image: saxGalleryAddBold,
  clockAlt: saxClockOutline,
  calendarAlt: saxCalendar1Outline,
  user: saxUserBold,
  users: saxProfile2userBold,
  document: saxDocumentBold,
  settings: saxSetting2Bold,
  logout: saxLogoutBold,
  dollar: saxDollarCircleBold,
  minus: saxMinusCirlceOutline,
  plus: saxAddCircleOutline,
  info: saxInfoCircleBold,
  leftNav: saxSidebarLeftBold,
  rightNav: saxSidebarRightBold,
  close: saxCloseCircleBold,
  tick: saxTickCircleBold,
  loading: saxRefreshOutline,
  cancel: saxMinusCirlceBold,
  send: saxSend2Bold,
  file: saxDocumentSketchBold,
  like: saxLikeShapesOutline,
  helpBulk: saxMessageQuestionBulk,
  help: saxMessageQuestionBold,
  filter: saxFilterBold,
  triangleUp: saxArrowUp1Bold,
  triangleDown: saxArrowDownBold,
  question: faSolidQuestion,
  equal: faSolidEquals,
  report: saxDocumentText1Bold,
  city: saxBuilding4Bold,
  cancelPerson: faSolidPersonCircleXmark,
  block: saxForbiddenBold,
  bank: saxBankBold,
  calendarAdd: saxCalendarAddBold,
  warning: saxWarning2Bold,
  addRoundedSquare: saxAddBold,
  minusRoundedSquareOutline: saxMinusSquareOutline,
  minusRoundedSquare: saxMinusBold,
  minusOutline: saxMinusOutline,
  shoppingCart: saxShoppingCartBold,
  rightArrow: saxArrowRight2Bold,
  leftArrow: saxArrowLeft3Bold,
  map: saxMap1Bold,
  clipboard: saxClipboardTextBold,
  lock: saxLockBold,
  arrowLeftOutline: saxArrowLeftOutline,
  sad: saxEmojiSadBold,
  userGroup: saxPeopleBold,
  printer: saxPrinterBold,
} as const;

export const REMIXICON_ICON_MAP = {
  checkmark: remixCheckFill,
  checkmarkDouble: remixCheckDoubleFill,
  wifiOnline: remixWifiFill,
  wifiOffline: remixWifiOffFill,
  cloudOff: remixCloudOffFill,
  cloudOn: remixCloudFill,
  community: remixUserCommunityFill,
  expandUpDown: remixExpandUpDownFill,
  prohibited: remixProhibitedLine,
  bug: remixBugLine,
  download: remixDownloadLine
};

export const ICON_MAP = {
  ...ICONSAX_ICON_MAP,
  ...REMIXICON_ICON_MAP,
} as const;

export type IconName =
  | keyof typeof ICON_MAP
  | 'amex'
  | 'mastercard'
  | 'visa'
  | 'oxxo-pay'
  | 'google';
